import { loadFullPage } from './utilidades/loadFullPage';
import { removeCacheUsuarioLogado } from './utilidades/usuarioLogado';
import { broadcastAuth } from './utilidades/authBroadcast';

const loginSair = function () {
    const init = function () {
        loadFullPage.mostrar();
        removeCacheUsuarioLogado();
        broadcastAuth('logout');
        return window.location.href = `/${CULTURE_EMPREGARE}`;
    };

    return init();
};

loginSair();